import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/api";

export function useUserDetail(customerId: string) {
  return useQuery({
    queryKey: ["user-detail", customerId],
    queryFn: () => apiCall<any>(`users/${encodeURIComponent(customerId)}`),
  });
}

export function useClubStatus(customerId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["club-status", customerId],
    queryFn: () => apiCall<any>(`users/${encodeURIComponent(customerId)}/club-status`),
    enabled,
  });
}
